(() => {
  if (window.__sampleStopVaultTrackingInstalled) return;
  window.__sampleStopVaultTrackingInstalled = true;

  const downloadSelector = "a[data-vault-download], a[href*='dropbox.com']";
  const delay = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

  window.addEventListener("click", async (event) => {
    const eventPath = typeof event.composedPath === "function" ? event.composedPath() : [event.target];
    const pathLink = eventPath.find((candidate) => candidate?.matches?.(downloadSelector));
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const link = pathLink || target?.closest?.(downloadSelector);
    if (!link) return;

    // Catch the click before page-builder or Dropbox navigation can end the page.
    event.preventDefault();
    if (link.dataset.vaultTrackingInFlight === "true") return;
    link.dataset.vaultTrackingInFlight = "true";

    const explicitContainer = link.closest("[data-vault-product-id], [data-vault-product-name]");
    const read = (name) => link.dataset[name] || explicitContainer?.dataset?.[name] || "";
    let node = link.parentElement;
    let relatedProductLink = null;
    let relatedHeading = null;
    while (node && node !== document.body) {
      relatedProductLink ||= [...node.querySelectorAll("a[href]")].find((candidate) => {
        if (candidate === link) return false;
        try { return new URL(candidate.href, window.location.href).pathname.includes("/products/"); }
        catch { return false; }
      }) || null;
      relatedHeading ||= node.querySelector("h1, h2, h3, h4, h5, h6, [data-product-name]");
      if (relatedProductLink && relatedHeading) break;
      node = node.parentElement;
    }
    const productId = String(read("vaultProductId")).replace(/^gid:\/\/shopify\/Product\//i, "").trim();
    const productName = read("vaultProductName").trim() || relatedHeading?.textContent?.trim() || "";
    const productUrl = read("vaultProductUrl").trim() || relatedProductLink?.href || "";
    const sampleName = read("vaultSampleName").trim() || (productName ? `${productName} free preview` : link.textContent.trim());

    const properties = {
      ProductID: productId || undefined,
      ProductName: productName || sampleName || "Vault sample",
      "Related Product Name": productName || undefined,
      ProductURL: productUrl || undefined,
      Category: read("vaultCategory").trim() || undefined,
      SampleName: sampleName || undefined,
      DownloadURL: link.href,
      PageURL: window.location.href,
      TrackerVersion: "vault-click-v3"
    };

    const destination = link.href;
    let navigationReleased = false;
    const releaseNavigation = () => {
      if (navigationReleased) return;
      navigationReleased = true;
      window.location.assign(destination);
    };
    window.setTimeout(releaseNavigation, 3000);

    try {
      // Klaviyo loads asynchronously. On a real email click it normally becomes
      // ready immediately, but waiting here removes the race with _kx identity.
      const readyUntil = Date.now() + 2000;
      while (typeof window.klaviyo?.track !== "function" && Date.now() < readyUntil) {
        await delay(50);
      }
      if (window.klaviyo && typeof window.klaviyo.track === "function") {
        await window.klaviyo.track("Vault Sample Downloaded", properties);
      } else {
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(["track", "Vault Sample Downloaded", properties]);
        await delay(500);
      }
    } catch (error) {
      console.warn("Vault Sample Downloaded tracking failed", error);
    } finally {
      releaseNavigation();
    }
  }, { capture: true });
})();
(function () {
  const DEFAULT_TEXT = 'Add';
  const IN_CART_TEXT = 'In Cart';
  const LOOP_KITS_PATH = '/collections/loop-kits';
  const WORKER_BASE = window.WORKER_BASE || 'https://sample-stop-tracker.thesamplestop.workers.dev';
  const SESSION_ID_KEY = 'sst_session_id_v1';
  const VISITOR_ID_KEY = 'sst_visitor_id_v1';
  const TRACKING_DISABLED_KEY = 'sst_tracking_disabled';
  const BUNDLE_STEPS = [
    { qty: 3, discount: 15 },
    { qty: 5, discount: 25 },
    { qty: 8, discount: 35 }
  ];

  let gpButtonsCache = null;
  let rowProductIdByVariantId = new Map();
  let lastCartVariantMap = {};
  let updateTimer = null;
  let cartSyncInFlight = false;
  let cartSyncQueued = false;
  let lastCartSyncAt = 0;
  let scheduledSyncDelays = {};
  let lastCartSignature = '';

  function isTrackingDisabled() {
    try {
      return localStorage.getItem(TRACKING_DISABLED_KEY) === '1';
    } catch (error) {
      return window.__sampleStopTrackingDisabled === true;
    }
  }

  function setTrackingDisabled(disabled) {
    const nextValue = disabled ? '1' : '0';

    try {
      localStorage.setItem(TRACKING_DISABLED_KEY, nextValue);
    } catch (error) {
    }

    window.__sampleStopTrackingDisabled = !!disabled;
    return !!disabled;
  }

  window.sampleStopTracking = Object.assign({}, window.sampleStopTracking, {
    disable: function () {
      setTrackingDisabled(true);
      return true;
    },
    enable: function () {
      setTrackingDisabled(false);
      return true;
    },
    isDisabled: function () {
      return isTrackingDisabled();
    }
  });

  function isLoopKitsPage() {
    return window.location.pathname.indexOf(LOOP_KITS_PATH) === 0;
  }

  function normalizeScalar(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function normalizeArray(value) {
    if (Array.isArray(value)) {
      return value.map(function (item) { return normalizeScalar(item); }).filter(Boolean);
    }
    const single = normalizeScalar(value);
    return single ? [single] : [];
  }

  function normalizeProductId(raw) {
    const text = normalizeScalar(raw);
    if (!text) return '';
    const match = text.match(/(\d+)$/);
    return match ? match[1] : text;
  }

  function getGpButtons(forceRefresh) {
    if (forceRefresh || !gpButtonsCache) {
      gpButtonsCache = Array.from(document.querySelectorAll('gp-product-button'));
    }

    return gpButtonsCache;
  }

  function createStableId(prefix) {
    return prefix + '_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function getOrCreateStorageId(storage, key, prefix) {
    try {
      const existing = storage.getItem(key);
      if (existing) return existing;
      const created = createStableId(prefix);
      storage.setItem(key, created);
      return created;
    } catch (error) {
      return createStableId(prefix);
    }
  }

  function getSessionId() {
    return getOrCreateStorageId(sessionStorage, SESSION_ID_KEY, 'sess');
  }

  function getVisitorId() {
    return getOrCreateStorageId(localStorage, VISITOR_ID_KEY, 'vis');
  }

  function postAnalyticsEvent(payload) {
    if (!payload || !payload.eventType) return Promise.resolve();
    if (isTrackingDisabled()) return Promise.resolve();

    try {
      return fetch(WORKER_BASE + '/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (error) {
      return Promise.resolve();
    }
  }

  window.sampleStopTrackInteractionEvent = function (payload) {
    if (!payload || !payload.eventType) return;

    postAnalyticsEvent({
      sessionId: getSessionId(),
      visitorId: getVisitorId(),
      pagePath: window.location.pathname,
      pageUrl: window.location.href,
      clickLocation: 'unknown',
      ...payload
    });
  };

  function getButtonParts(wrapper) {
    const button = wrapper.querySelector('button[name="add"], button[type="submit"]');
    const text = wrapper.querySelector('[data-gp-text], .button-text');
    const icon = wrapper.querySelector('.gp-button-icon');
    return { button: button, text: text, icon: icon };
  }

  function getVariantId(wrapper) {
    const raw = wrapper.getAttribute('gp-data');
    if (!raw) return null;

    try {
      const data = JSON.parse(raw);
      return data && data.variantID ? String(data.variantID) : null;
    } catch (error) {
      return null;
    }
  }

  function setState(wrapper, inCart) {
    const parts = getButtonParts(wrapper);
    const button = parts.button;
    const text = parts.text;
    const icon = parts.icon;

    if (!button || !text) return;

    text.textContent = inCart ? IN_CART_TEXT : DEFAULT_TEXT;
    button.setAttribute('aria-label', inCart ? IN_CART_TEXT : DEFAULT_TEXT);
    button.classList.toggle('is-in-cart', inCart);

    if (icon) {
      icon.style.display = inCart ? 'none' : '';
    }
  }

  function getBundleMessage(count, compact) {
    if (count >= 8) {
      return '35% off unlocked';
    }

    if (count >= 5) {
      return 'Add ' + (8 - count) + ' more kits for 35% off';
    }

    if (count >= 3) {
      return 'Add ' + (5 - count) + ' more kits for 25% off';
    }

    return 'Add ' + (3 - count) + ' kits for 15% off';
  }

  function getProgressPercent(count) {
    if (count <= 0) return 0;
    if (count >= 8) return 100;
    if (count <= 3) return (count / 3) * 33.33;
    if (count <= 5) return 33.33 + ((count - 3) / 2) * 33.33;
    return 66.66 + ((count - 5) / 3) * 33.34;
  }

  function openCartFromHeaderTrigger() {
    const headerCartLink = Array.from(document.querySelectorAll('a[href="/cart"], a[href$="/cart"]'))
      .find(function (link) {
        return link.querySelector('.icon-cart') || link.querySelector('.header__cart-count');
      });

    if (headerCartLink) {
      headerCartLink.click();
      return;
    }

    window.location.href = '/cart';
  }

  function ensureTracker() {
    let tracker = document.getElementById('bundle-progress-pill');
    if (tracker) return tracker;

    tracker = document.createElement('div');
    tracker.id = 'bundle-progress-pill';
    tracker.innerHTML = [
      '<div class="bundle-pill__content" role="status" aria-live="polite">',
      '<div class="bundle-pill__left-grid">',
      '<div class="bundle-pill__text-wrap">',
      '<span class="bundle-pill__message"></span>',
      '<span class="bundle-pill__track">',
      '<span class="bundle-pill__fill"></span>',
      '<span class="bundle-pill__dot bundle-pill__dot--1"></span>',
      '<span class="bundle-pill__dot bundle-pill__dot--2"></span>',
      '<span class="bundle-pill__dot bundle-pill__dot--3"></span>',
      '</span>',
      '</div>',
      '</div>',
      '<div class="bundle-pill__cart-col">',
      '<button class="bundle-pill__cart-button" type="button" aria-label="Open cart">',
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
      '<path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2Zm10 0c-1.1 0-1.99.9-1.99 2S15.9 22 17 22s2-.9 2-2-.9-2-2-2ZM7.17 14h9.92c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1 1 0 0 0 21.54 5H6.21l-.7-1.49A1 1 0 0 0 4.6 3H2v2h1.96l3.6 7.59-1.35 2.44A2 2 0 0 0 8 18h12v-2H8l1.17-2Z"></path>',
      '</svg>',
      '</button>',
      '</div>',
      '</div>',
      '</div>'
    ].join('');

    tracker.querySelector('.bundle-pill__cart-button').addEventListener('click', function () {
      openCartFromHeaderTrigger();
    });

    document.body.appendChild(tracker);
    return tracker;
  }

  function getThemeAssetUrl(assetName) {
    const script = Array.from(document.querySelectorAll('script[src]')).find(function (node) {
      return /\/assets\/custom\.js(\?|$)/.test(node.src);
    });

    if (!script) return null;

    const url = new URL(script.src, window.location.origin);
    url.pathname = url.pathname.replace(/\/assets\/custom\.js$/, '/assets/' + assetName);
    url.search = '';
    return url.toString();
  }

  function getProductCardRoot(productNode) {
    if (!productNode) return null;
    let current = productNode;
    let highestGpRow = null;

    while (current && current !== document.body) {
      if (current.tagName === 'GP-ROW') {
        highestGpRow = current;
      }
      current = current.parentElement;
    }

    return (
      highestGpRow ||
      productNode.closest('.mobile-loop-row') ||
      productNode.closest('.gp-custom-code') ||
      productNode.parentElement ||
      null
    );
  }

  function buildRowLookupFromDom() {
    getGpButtons(true);
    rowProductIdByVariantId = new Map();

    document.querySelectorAll('[data-product-id]').forEach(function (productNode) {
      const cardRoot = getProductCardRoot(productNode);
      const buttonWrapper = cardRoot ? cardRoot.querySelector('gp-product-button') : null;

      const productId = normalizeProductId(productNode.getAttribute('data-product-id'));
      const variantId = buttonWrapper ? getVariantId(buttonWrapper) : null;
      if (productId && variantId) {
        rowProductIdByVariantId.set(String(variantId), productId);
      }
    });
  }

  function syncButtons(cart) {
    const variantMap = {};

    (cart.items || []).forEach(function (item) {
      variantMap[String(item.variant_id)] = item.quantity;
    });

    getGpButtons().forEach(function (wrapper) {
      const variantId = getVariantId(wrapper);
      if (!variantId) return;

      setState(wrapper, (variantMap[variantId] || 0) > 0);
    });

    lastCartVariantMap = variantMap;
  }

  function getCartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';
    return cart.items
      .map(function (item) {
        return String(item.variant_id) + ':' + String(item.quantity || 0);
      })
      .sort()
      .join('|');
  }

  function refreshImpactCartUI() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  function scheduleTrackerUpdate() {
    if (!isLoopKitsPage()) return;
    if (updateTimer) return;
    updateTimer = window.setTimeout(function () {
      updateTimer = null;
      updateTracker();
    }, 40);
  }

  function updateTracker() {
    if (!isLoopKitsPage()) {
      const existingTracker = document.getElementById('bundle-progress-pill');
      if (existingTracker) {
        existingTracker.classList.remove('is-visible');
      }
      return;
    }

    const tracker = ensureTracker();
    const message = tracker.querySelector('.bundle-pill__message');
    const fill = tracker.querySelector('.bundle-pill__fill');
    const dots = tracker.querySelectorAll('.bundle-pill__dot');
    const count = Object.keys(lastCartVariantMap).reduce(function (sum, variantId) {
      return sum + (lastCartVariantMap[variantId] || 0);
    }, 0);

    if (!tracker || !message || !fill) {
      return;
    }

    tracker.classList.add('is-visible');
    message.textContent = getBundleMessage(count, window.innerWidth <= 749);
    fill.style.width = getProgressPercent(count) + '%';

    dots.forEach(function (dot, index) {
      const step = BUNDLE_STEPS[index];
      dot.classList.toggle('is-active', count >= step.qty);
    });
  }

  function syncAll(cart) {
    syncButtons(cart);
    scheduleTrackerUpdate();
    const nextSignature = getCartSignature(cart);
    if (nextSignature !== lastCartSignature) {
      lastCartSignature = nextSignature;
      refreshImpactCartUI();
    }
  }

  function fetchCartAndSync(force) {
    const now = Date.now();

    if (cartSyncInFlight) {
      cartSyncQueued = true;
      return;
    }

    if (!force && now - lastCartSyncAt < 900) {
      cartSyncQueued = true;
      window.setTimeout(function () {
        if (cartSyncQueued && !cartSyncInFlight) {
          cartSyncQueued = false;
          fetchCartAndSync(true);
        }
      }, 950);
      return;
    }

    cartSyncInFlight = true;
    lastCartSyncAt = now;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) { syncAll(cart); })
      .catch(function () {})
      .finally(function () {
        cartSyncInFlight = false;
        if (cartSyncQueued) {
          cartSyncQueued = false;
          window.setTimeout(function () {
            fetchCartAndSync(true);
          }, 250);
        }
      });
  }

  function deferInitialCartSync() {
    window.setTimeout(function () {
      if (getGpButtons().length) {
        fetchCartAndSync();
      }
    }, 650);
  }

  function scheduleSync() {
    [300, 1100].forEach(function (delay) {
      if (scheduledSyncDelays[delay]) return;
      scheduledSyncDelays[delay] = window.setTimeout(function () {
        scheduledSyncDelays[delay] = null;
        fetchCartAndSync(true);
      }, delay);
    });
  }

  const originalFetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0];
    const requestUrl = typeof url === 'string' ? url : (url && url.url ? url.url : '');

    return originalFetch.apply(this, arguments).then(function (response) {
      if (
        requestUrl.indexOf('/cart/add') > -1 ||
        requestUrl.indexOf('/cart/change') > -1 ||
        requestUrl.indexOf('/cart/update') > -1 ||
        requestUrl.indexOf('/cart/clear') > -1
      ) {
        scheduleSync();
      }
      return response;
    });
  };

  document.addEventListener('variant:add', function (event) {
    if (event.detail && event.detail.cart) {
      syncAll(event.detail.cart);
    } else {
      scheduleSync();
    }
  });

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      syncAll(event.detail.cart);
    } else {
      scheduleSync();
    }
  });

  document.addEventListener('line-item:change', function (event) {
    if (event.detail && event.detail.cart) {
      syncAll(event.detail.cart);
    } else {
      scheduleSync();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    buildRowLookupFromDom();
    if (isLoopKitsPage()) {
      ensureTracker();
      updateTracker();
    }
    deferInitialCartSync();
  });

  window.addEventListener('pageshow', function () {
    buildRowLookupFromDom();
    if (isLoopKitsPage()) {
      updateTracker();
    }

    if (getGpButtons().length) {
      fetchCartAndSync();
    }
  });

  const style = document.createElement('style');
  style.textContent = `
    gp-product-button button.is-in-cart {
      --bg: #fff8f4 !important;
      --hvr-bg: #fff1ea !important;
      --c: #f46d29 !important;
      box-shadow: inset 0 0 0 2px #f46d29;
      transition: all 0.2s ease;
    }

    gp-product-button button.is-in-cart::before {
      border-color: transparent !important;
    }

    #bundle-progress-pill {
      position: fixed;
      left: 50%;
      bottom: 18px;
      transform: translateX(-50%) translateY(20px);
      width: min(calc(100vw - 24px), 520px);
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 12px 14px;
      border: 1px solid rgba(244, 109, 41, 0.14);
      border-radius: 8px;
      background: rgba(255, 251, 247, 0.97);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.25s ease, transform 0.25s ease;
      z-index: 9999;
    }

    #bundle-progress-pill.is-visible {
      opacity: 1;
      pointer-events: auto;
      transform: translateX(-50%) translateY(0);
    }

    .bundle-pill__content {
      flex: 1 1 auto;
      min-width: 0;
      text-align: left;
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 12px;
      align-items: center;
    }

    .bundle-pill__left-grid {
      min-width: 0;
    }

    .bundle-pill__text-wrap {
      min-width: 0;
    }

    .bundle-pill__message {
      display: block;
      color: #f46d29;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.35;
    }

    .bundle-pill__track {
      position: relative;
      display: block;
      margin-top: 10px;
      height: 6px;
      border-radius: 999px;
      background: #eadfd8;
    }

    .bundle-pill__cart-col {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
    }

    .bundle-pill__fill {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 0;
      border-radius: 999px;
      background: linear-gradient(90deg, #f58549 0%, #f46d29 100%);
      transition: width 0.3s ease;
    }

    .bundle-pill__dot {
      position: absolute;
      top: 50%;
      width: 14px;
      height: 14px;
      border: 2px solid #d3c4bc;
      border-radius: 999px;
      background: #fff;
      transform: translate(-50%, -50%);
      transition: all 0.25s ease;
    }

    .bundle-pill__dot.is-active {
      border-color: #f46d29;
      background: #f46d29;
      box-shadow: 0 0 0 3px rgba(244, 109, 41, 0.15);
    }

    .bundle-pill__dot--1 { left: 33.33%; }
    .bundle-pill__dot--2 { left: 66.66%; }
    .bundle-pill__dot--3 { left: 100%; }

    .bundle-pill__cart-button {
      width: 42px;
      height: 42px;
      border: 2.5px solid #f46d29;
      border-radius: 8px;
      background: transparent;
      color: #f46d29;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
      flex: 0 0 auto;
    }

    .bundle-pill__cart-button:hover {
      background: rgba(244, 109, 41, 0.08);
      transform: translateY(-1px);
    }

    .bundle-pill__cart-button svg {
      width: 16px;
      height: 16px;
      display: block;
      fill: currentColor;
    }

    @media screen and (max-width: 749px) {
      #bundle-progress-pill {
        bottom: 12px;
        width: calc(100vw - 20px);
        padding: 12px;
        border-radius: 4px;
        gap: 10px;
      }

      .bundle-pill__content {
        gap: 10px;
      }

      .bundle-pill__message {
        font-size: 13px;
      }

      .bundle-pill__cart-button {
        width: 38px;
        height: 38px;
      }

      .bundle-pill__cart-button svg {
        width: 15px;
        height: 15px;
      }
    }
  `;
  document.head.appendChild(style);
})();
